export default "__VITE_PUBLIC_ASSET__04619a94__"